module.exports = __webpack_public_path__ + "media/images/audio-2b78d5d2badf886f3984f2ecfa3f76ba.svg";